import { useCallback } from "react";
import { StringParam, useQueryParam } from "use-query-params";

interface UseDebugModeQueryResult {
  isDebugMode: boolean;
  setDebugMode: (isEnabled: boolean) => void;
}

/**
 * Reads and writes the exact `debugMode=true` URL contract.
 * StringParam is required because BooleanParam serializes true as `1`.
 */
export const useDebugModeQuery = (): UseDebugModeQueryResult => {
  const [debugModeParam, setDebugModeParam] = useQueryParam("debugMode", StringParam);

  const setDebugMode = useCallback(
    (isEnabled: boolean) => {
      setDebugModeParam(isEnabled ? "true" : undefined, "replaceIn");
    },
    [setDebugModeParam]
  );

  return {
    isDebugMode: debugModeParam === "true",
    setDebugMode,
  };
};
